"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Footer = () => (react_1.default.createElement("footer", { className: "footer" },
    "Unless otherwise stated, the content of this page is licensed under",
    ' ',
    react_1.default.createElement("a", { href: "https://creativecommons.org/licenses/by-sa/3.0/", target: "_blank", rel: "noopener noreferrer" }, "Creative Commons Attribution-ShareAlike 3.0 License")));
exports.default = Footer;
//# sourceMappingURL=Footer.js.map